import CarpentryCostC from "../../containers/admin-rates/CarpentryCostC";

type Props = {};

const CarpentryCost = (props: Props) => {
  return <CarpentryCostC />;
};

export default CarpentryCost;
